import { ZfBox, ZfInput, ZfStack, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useTalkingPoints } from '../../../api';
import type { TalkingPointDto } from '../../../api/generated/client';

interface IProps {
    onCreateClick: () => void;
    onPointClick: (pointId: number) => void;
}

export const TalkingPointSearch: FunctionComponent<IProps> = ({ onCreateClick, onPointClick }) => {
    const { i18n, t } = useTranslation();
    const { data: talkingPoints } = useTalkingPoints();

    const [searchValue, setSearchValue] = useState('');

    const visiblePoints = useMemo(() => {
        const points = talkingPoints ?? [];
        const filterPointsBySearch = (point: TalkingPointDto) => JSON.stringify(point.name).toLowerCase().includes(searchValue.toLowerCase());

        return searchValue.length > 2 ? points.filter(filterPointsBySearch) : points;
    }, [searchValue, talkingPoints]);

    if (!talkingPoints) return null;

    return (
        <ZfStack direction="column" spacing="large" style={{ flex: 1, height: '400px' }}>
            <ZfTextButton hierarchy="secondary" onClick={onCreateClick}>
                {t('contentAdmin.createNewItem')}
            </ZfTextButton>
            <ZfInput
                type="search"
                value={searchValue}
                placeholder={t('contentAdmin.searchTalkingPoints')}
                showSubmit={true}
                clearable={false}
                onInputChange={(e) => setSearchValue(e.detail)}
            />
            <ZfBox style={{ overflow: 'auto', flex: 1 }}>
                {visiblePoints.map((point, idx) => (
                    <ZfBox key={point.id} className={`talking-point-search-list-item ${idx === 0 ? 'first-item' : ''}`} onClick={() => onPointClick(point.id)}>
                        {point.name[i18n.language]}
                    </ZfBox>
                ))}
            </ZfBox>
        </ZfStack>
    );
};
